import React from 'react';
import classNames from 'classnames';
import { Tooltip as AntdTooltip } from 'antd';
import { RenderFunction } from 'antd/es/tooltip/index';
import { TooltipPlacement } from 'antd/es/tooltip/index';
import { PresetColorTypes } from '../_util/colors';
import { ConfigContext } from '../config-provider';
import AntdConfigProvider from 'antd/es/config-provider';
export const Tooltip = (props) => {
    const { prefixCls, overlayClassName, color } = props;
    const PresetColorRegex = new RegExp(`^(${PresetColorTypes.join('|')})(-inverse)?$`);
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('tooltip', prefixCls);
    const rootPrefixCls = getPrefixCls();
    let tooltipColor = !color ? '' : color.toLocaleLowerCase().replace(/\s/g, '-');
    const isPresetColor = () => {
        if (!color) {
            return false;
        }
        return PresetColorRegex.test(tooltipColor);
    };
    const presetColor = isPresetColor();
    const newClassName = classNames(overlayClassName, {
        [`${classPrefix}-${tooltipColor}`]: presetColor
    });
    return (React.createElement(AntdConfigProvider, { prefixCls: getPrefixCls('', prefixCls), ...restContext },
        React.createElement(AntdTooltip, { prefixCls: prefixCls, ...props, overlayClassName: newClassName })));
};
export default Tooltip;
// export default withConfigProvider(Tooltip);
